import { Component } from '@theme/component';

/**
 * Horizontal peek-carousel for review cards. Scroll-snap does the actual
 * scrolling and touch/keyboard support natively; this only drives the two
 * arrow buttons by scrolling one card width at a time.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} track
 *
 * @extends {Component<Refs>}
 */
export class DrappCarousel extends Component {
  requiredRefs = ['track'];

  next() {
    this.scrollByCard(1);
  }

  prev() {
    this.scrollByCard(-1);
  }

  /**
   * @param {1 | -1} direction
   */
  scrollByCard(direction) {
    const track = this.refs.track;
    const card = track.querySelector(':scope > *');
    if (!card) return;

    const gap = parseFloat(getComputedStyle(track).columnGap || '0');
    const amount = card.getBoundingClientRect().width + gap;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }
}

if (!customElements.get('drapp-carousel-component')) {
  customElements.define('drapp-carousel-component', DrappCarousel);
}
